/**
 * Checks if a value is considered empty.
 * A value is empty if it is null, undefined, an empty/whitespace-only string, or an empty array.
 *
 * @param value - The value to check
 * @returns true if the value is empty, false otherwise
 *
 * @example
 * isEmptyValue(null) // true
 * isEmptyValue(undefined) // true
 * isEmptyValue("") // true
 * isEmptyValue("   ") // true
 * isEmptyValue([]) // true
 * isEmptyValue("hello") // false
 * isEmptyValue([1, 2]) // false
 */
function isEmptyValue(value: unknown): boolean {
  if (value === null || value === undefined) {
    return true;
  }

  if (typeof value === "string") {
    return value.trim() === "";
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  return false;
}

export { isEmptyValue };
